import React from "react";
import { useLocation, matchPath } from "react-router-dom";
import { Grid, Container, Box, Typography, Button, IconButton } from "@mui/material";
import FiberNewIcon from '@mui/icons-material/FiberNew';
import { SiteRouterLink } from "../../components/RouterLink";
import { useI18n } from "@haohan/root-locales";
import { makeStyles } from 'tss-react/mui';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { locales, useMenu } from "./config";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { SiteRouterButtonLink } from "../../components/RouterButtonLink";
import { HaohanH1 } from "../../components/HaohanH1";
import { useAppCtx } from "../../AppStore";
import { AccountButton } from "./ AccountButton";
// import { SiteHeaderLanguages } from "./Languages";

const useStyles = makeStyles({name: "AppHeader"})(theme => ({
	header: {
		position: "relative",
		// boxShadow: "0 9px 14px -5px rgba(0, 0, 0, .10)",
		// background: theme.palette.background.paper,
		width: '100%',
		overflow: 'hidden'
	},
	topBar: {
	//	backgroundColor: theme.palette.background.default
	},
	topNav: {
		display: 'flex',
		alignItems: 'center',
		height: '3.5rem',
	},
	menuItem: {
		display: 'inline-flex',
		alignItems: 'center',
		boxSizing: 'border-box',
		fontSize: 12,
		fontWeight: 500,
		textTransform: 'uppercase',
		color: theme.palette.text.secondary,
		cursor: 'pointer',
		whiteSpace: 'nowrap',

		'&:hover': {
			color: theme.palette.text.primary,
			opacity: .8,
		}
	},
	menuItemActive: {
		color: theme.palette.primary.dark,
	},
	searchInputWrapper: {
		maxWidth: 400,
		width: '100%',
	},
	flagItem: {
		width: 28,
		height: 28,
		borderRadius: "50%",
		overflow: "hidden",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		boxShadow: theme.shadows[3],
		boxSizing: "border-box",
		cursor: "pointer",
		backgroundClip: "content-box",
		backgroundSize: "cover",
		border: `1px solid transparent`,
		backgroundPosition: "center center",
		opacity: .2,
		margin: "0 4px",
	},
	flagItemActive: {
		opacity: 1,
		padding: 1,
		borderColor: theme.palette.primary.light
	}
}));

export function SiteDesktopHeader() {
	const { classes, cx } = useStyles();
	const { t, lang } = useI18n();
	const location = useLocation();
	const menu = useMenu(t, lang);
	const { activeUser } = useAppCtx();
	return (
		<>
			<header className={classes.header}>
				<div className={classes.topBar}>
					<Container maxWidth='lg'>
						<Grid
							container
							py={.5}
							alignItems='center'
							justifyContent='space-between'
							wrap='nowrap'
						>
							<Grid item>
								<HaohanH1 lang={lang} />
							</Grid>
							<Grid item>
								<div className={classes.topNav}>
									{menu.map((item, idx) => {
										const isActive = Boolean(
											matchPath(
												{
													path: `/${lang}/${item.path}`,
													end: false
												},
												location.pathname,
											)
										);
										return (
											<Box key={idx} mx={1.4}>
												<SiteRouterLink
													className={cx(
														classes.menuItem, {
															[classes.menuItemActive]: isActive
														}
													)}
													color={isActive ? 'primary' : 'default'}
													to={`/${item.path}`}
													underline='none'
												>
													{item.label}
													{item.new && (
														<FiberNewIcon color='primary' fontSize='small' />
													)}
												</SiteRouterLink>
											</Box>
										);
									})}
								</div>
							</Grid>
							<Grid item>
								<AccountButton />
							</Grid>
						</Grid>
					</Container>
				</div>
			</header>
		</>
	);
}
